export const payWithPowerAbi = [
  {
    name: 'payWithPower',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      {
        name: 'order',
        type: 'tuple',
        components: [
          { name: 'orderId', type: 'bytes32' },
          { name: 'validUntil', type: 'uint256' },
          { name: 'price', type: 'uint256' },
        ],
      },
      { name: 'signature', type: 'bytes' },
    ],
    outputs: [],
  },
] as const;
